import lodash from 'lodash';

/**
 * Set global so you don't have to import it
 */
window._ = lodash;
